export const heroSlides = [
  {
    id: 1,
    title: "Visa Services Made Simple",
    subtitle: "From urgent Schengen to complex cases - we handle everything so you don't have to.",
    cta: "Explore Our Services",
    ctaLink: "/award",
    backgroundImage: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=1920&q=80",
    country: "Dubai"
  },
  {
    id: 2,
    title: "🇺🇸 US Visa in 2 Weeks",
    subtitle: "Spring in California or FIFA 2026 this summer - the choice is yours",
    cta: "Get US Visa!",
    ctaLink: "/services/usa-urgent-visa",
    backgroundImage: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=1920&q=80",
    country: "USA"
  },
  {
    id: 3,
    title: "🇪🇺 Schengen Visa From 3 Days",
    subtitle: "Alps in winter or Paris in spring - it's the perfect time to plan your trip",
    cta: "Get Schengen!",
    ctaLink: "/services/urgent-schengen-visa",
    backgroundImage: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1920&q=80",
    country: "Europe"
  },
  {
    id: 4,
    title: "🇯🇵 Japan Visa in 4 Days",
    subtitle: "Winter onsens or spring sakura - the choice is yours",
    cta: "Go!",
    ctaLink: "/services/japan-visa",
    backgroundImage: "https://images.unsplash.com/photo-1542051841857-5f90071e7989?w=1920&q=80",
    country: "Japan"
  }
];

export const navigationMenu = [
  {
    name: "Schengen",
    path: "/schengen",
    submenu: [
      { name: "Urgent Schengen", path: "/services/urgent-schengen-visa" },
      { name: "Visa To Italy", path: "/services/italian-visa" },
      { name: "Visa To Spain", path: "/services/spanish-visa" },
      { name: "Visa To France", path: "/services/french-visa" },
      { name: "Visa To Switzerland", path: "/services/switzerland-visa" },
      { name: "Schengen For Domestic Workers", path: "/services/visa-for-domestic-workers" },
      { name: "Other services", path: "/our-services" }
    ]
  },
  {
    name: "USA & UK",
    path: "/urgent-services",
    submenu: [
      { name: "Urgent USA Visa", path: "/services/usa-urgent-visa" },
      { name: "Regular US Visa", path: "/services/us-visa" },
      { name: "Renewing US Visa", path: "/services/renewing-us-visa-in-dubai" },
      { name: "US Student Visa F1", path: "/services/usa-study-visa" },
      { name: "Urgent UK Visa", path: "/services/urgent-uk-visa" },
      { name: "Regular UK Visa", path: "/services/uk-visa-2" },
      { name: "UK Student Visa", path: "/services/uk-student-visa" },
      { name: "US, UK Visas For Domestic Workers", path: "/services/visa-for-domestic-workers" }
    ]
  },
  {
    name: "Other Visas",
    path: "/other-services",
    submenu: [
      { name: "Visa To Japan", path: "/services/japan-visa" },
      { name: "Visa To China", path: "/services/china-visa" },
      { name: "Visa To South Africa", path: "/services/visa-to-south-africa" },
      { name: "Visa To Canada", path: "/services/canada-visa" },
      { name: "Visa To Russia", path: "/services/russia-visa" },
      { name: "Visa To Cyprus", path: "/services/cyprus" },
      { name: "Visa To Saudi Arabia", path: "/services/saudi-arabia-visa" },
      { name: "Visa To Turkey", path: "/services/turkey-visa" },
      { name: "Visa To Singapore", path: "/services/singapore-visa" },
      { name: "Visa To Australia", path: "/services/australia-visa" },
      { name: "Visa To New Zealand", path: "/services/new-zealand-visa" },
      { name: "Visa To Bali", path: "/services/visa-to-bali" }
    ]
  },
  {
    name: "UAE Services",
    path: "/uae-services",
    submenu: [
      { name: "Digital Nomad Visa", path: "/services/digital-nomad-visa" },
      { name: "Freelance Visa", path: "/services/uae-freelance-visa" },
      { name: "Golden Visa", path: "/services/uae-golden-visa" },
      { name: "Bank Account Opening", path: "/services/uae-bank-account" },
      { name: "Business Setup In UAE", path: "/services/uae-business-setup" }
    ]
  },
  {
    name: "About us",
    path: "/about",
    submenu: [
      { name: "Contact Us", path: "/contacts" },
      { name: "Affiliate program", path: "/partnership" },
      { name: "Careers", path: "/vacancies" },
      { name: "Blog", path: "/blog" },
      { name: "Media about us", path: "/press" },
      { name: "Privacy Notice", path: "/services/privacy-notice" }
    ]
  }
];

export const services = [
  {
    id: 1,
    name: "Urgent Schengen Visa",
    duration: "From 3 days",
    image: "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=600&q=80",
    link: "/services/urgent-schengen-visa"
  },
  {
    id: 2,
    name: "Urgent US Visa",
    duration: "From 2 weeks",
    image: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=600&q=80",
    link: "/services/usa-urgent-visa"
  },
  {
    id: 3,
    name: "Urgent UK Visa",
    duration: "From 1 day",
    image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=600&q=80",
    link: "/services/urgent-uk-visa"
  },
  {
    id: 4,
    name: "Visa to China",
    duration: "From 4 days",
    image: "https://images.unsplash.com/photo-1508804185872-d7badad00f7d?w=600&q=80",
    link: "/services/china-visa"
  }
];

export const expertiseStats = [
  { label: "years experience", value: "8" },
  { label: "Personal assistant", value: "✓" },
  { label: "Best time for urgent visas", value: "✓" },
  { label: "Visas issued", value: "20,000" },
  { label: "Google review", value: "4.7★" }
];

export const differenceStats = [
  {
    title: "RELY ON US AND GET 45% INCREASE",
    subtitle: "IN APPROVAL RATE",
    description: "Trust our expert team to guide you through the whole documentation process"
  },
  {
    title: "SAVE UP TO 30 HOURS",
    subtitle: "",
    description: "By skipping the stress of booking and paperwork"
  },
  {
    title: "KEEP YOUR PLANS MOVING",
    subtitle: "",
    description: "Be ready to attend your appointment in just 2 days!"
  }
];

export const mediaArticles = [
  {
    id: 1,
    source: "Gulf News",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Gulf_News_logo.svg/320px-Gulf_News_logo.svg.png",
    title: "US visa pause: Embassy in UAE clarifies visa rules for FIFA World Cup 2026 travellers",
    link: "https://gulfnews.com/business/tourism/us-visa-pause-embassy-in-uae-clarifies-visa-rules-for-fifa-world-cup-2026-travellers-1.500413323"
  },
  {
    id: 2,
    source: "Khaleej Times",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Khaleej_Times_logo.svg/320px-Khaleej_Times_logo.svg.png",
    title: "UAE: Female-led travel grows by 18% as momcations, solo trips rise",
    link: "https://www.khaleejtimes.com/uae/female-led-travel-grows-momcations-solo-trips-rise"
  },
  {
    id: 3,
    source: "Gulf News",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Gulf_News_logo.svg/320px-Gulf_News_logo.svg.png",
    title: "Snow or sun? Where UAE winter travellers will escape to this year",
    link: "https://gulfnews.com/business/tourism/snow-or-sun-where-uae-winter-travellers-will-escape-to-this-year-1.500327986"
  }
];

export const countries = [
  { name: "Afghanistan", code: "+93", flag: "🇦🇫" },
  { name: "Albania", code: "+355", flag: "🇦🇱" },
  { name: "Algeria", code: "+213", flag: "🇩🇿" },
  { name: "United Arab Emirates", code: "+971", flag: "🇦🇪" },
  { name: "United States", code: "+1", flag: "🇺🇸" },
  { name: "United Kingdom", code: "+44", flag: "🇬🇧" },
  { name: "India", code: "+91", flag: "🇮🇳" },
  { name: "Pakistan", code: "+92", flag: "🇵🇰" },
  { name: "Bangladesh", code: "+880", flag: "🇧🇩" },
  { name: "Saudi Arabia", code: "+966", flag: "🇸🇦" }
];